module.exports = __webpack_public_path__ + "img/partners_grid.f1c61f69.png";